import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

import { toRefs } from 'vue';

// Personal libs
import { DeviceOrientationEnum } from 'src/shared/enum/device-orientation.enum';

// ViewModel
import { useQPageTitle } from 'src/view/viewmodel/components/qPageTitle.vm';
import { useGlobalVM } from 'src/view/viewmodel/global.vm';

// Personal components
import QHeadful from 'src/view/components/QHeadful.vue';

/**
 * Viewmodel
 */
interface Props {
  title: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'QPageTitle',
  props: {
    title: { default: '' }
  },
  setup(__props: any) {

// Vendor
const { isMobile } = useGlobalVM();

/**
 * Properties
 */
const props = __props;
const { title } = toRefs(props);

/**
 * ViewModel
 */
const {
  // Computed properties
  doAlignCenter,
  orientation,
} = useQPageTitle(title);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(QHeadful, { title: _unref(title) }, null, 8 /* PROPS */, ["title"]),
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("h2", {
          key: 0,
          class: _normalizeClass({
      'text-center': _unref(doAlignCenter),
      'q-mb-md h2-mt-more': _unref(orientation) === _unref(DeviceOrientationEnum).PORTRAIT,
      'h2-mt-less': _unref(orientation) === _unref(DeviceOrientationEnum).LANDSCAPE,
    })
        }, _toDisplayString(_unref(title)), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})